export function Progress({ current, total }: { current: number; total: number }) {
  const pct = total === 0 ? 0 : Math.min(100, (current / total) * 100);
  return (
    <div className="flex items-center gap-3">
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-tg-secondary-bg">
        <div
          className="h-full bg-tg-button transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs text-tg-hint tabular-nums">
        {current}/{total}
      </span>
    </div>
  );
}
